import { ReactNode } from 'react'

import { cn } from '@/utils'

const PageWrapper = ({
  children,
  className
}: {
  children: ReactNode
  className?: string
}) => {
  return (
    <div
      className={cn(
        `flex min-h-screen flex-col bg-zinc-950 text-white`,
        className
      )}
    >
      {children}
    </div>
  )
}

export default PageWrapper
